export function displayCurrency(cents: number): string {
  if (isNaN(cents)) {
    throw new Error("Invalid input: cents must be a number");
  }

  const dollars = cents / 100;
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
